// Layer 3 (Transformation): pure lookups over the Met Diagnostics register
// (`met-diagnostics-cause.ts` / `bunker-hill-met-diagnostics-register.ts`).
// No React, no engine mutation.

import type { MetDiagnosticsCause } from '@/versions/v1/schema/met-diagnostics-cause';
import { MET_DIAGNOSTICS_CAUSES } from '@/versions/v1/shared/bunker-hill-met-diagnostics-register';
import { projectSidebarHref } from '@/versions/v1/shared/project-sidebar-nav';

const CAUSE_BY_ID = new Map(MET_DIAGNOSTICS_CAUSES.map((cause) => [cause.id, cause]));

export function metDiagnosticsCauseById(id: string): MetDiagnosticsCause | undefined {
  return CAUSE_BY_ID.get(id);
}

/** Where a row routes for one MD-### cause — the Advisory rule set, deep
 *  linked to the cause's own row (`?tab=rule-set&cause=MD-060`), the same
 *  way a stage-ladder row's `nodeHref` deep links to the plant model. */
export function metDiagnosticsCauseHref(slug: string, causeId: string): string {
  return `${projectSidebarHref(slug, 'advisory')}?tab=rule-set&cause=${causeId}`;
}

/** Workbook L/P readout for one or more cause rows — tooltip-only on the stage ladder (#299). */
export function workbookTooltipForCauseIds(causeIds: readonly string[]): string | undefined {
  const parts = causeIds
    .map((id) => {
      const cause = metDiagnosticsCauseById(id);
      if (!cause) return null;
      return `${cause.cause.split(' — ')[0] ?? cause.cause} L${cause.likelihood} · #${cause.priority}`;
    })
    .filter((part): part is string => Boolean(part));
  if (parts.length === 0) return undefined;
  return `Paul's workbook · ${parts.join(' · ')}`;
}
